import { useTranslation } from 'react-i18next'

// Compact timezone dropdown component
// Common timezones grouped by region for optgroup
function TimezoneDropdown({ timezone, onChange }) {
  const { t } = useTranslation('settings')

  const TIMEZONE_OPTIONS = [
    {
      label: t('timezone.regions.europe'),
      timezones: [
        { value: 'Europe/Berlin', label: 'Berlin (CEST, UTC+2)' },
        { value: 'Europe/London', label: 'London (BST, UTC+1)' },
        { value: 'Europe/Paris', label: 'Paris (CEST, UTC+2)' },
        { value: 'Europe/Madrid', label: 'Madrid (CEST, UTC+2)' },
        { value: 'Europe/Rome', label: 'Rom (CEST, UTC+2)' },
        { value: 'Europe/Amsterdam', label: 'Amsterdam (CEST, UTC+2)' },
        { value: 'Europe/Vienna', label: 'Wien (CEST, UTC+2)' },
        { value: 'Europe/Zurich', label: 'Zürich (CEST, UTC+2)' },
        { value: 'Europe/Stockholm', label: 'Stockholm (CEST, UTC+2)' },
        { value: 'Europe/Warsaw', label: 'Warschau (CEST, UTC+2)' },
      ]
    },
    {
      label: t('timezone.regions.northAmerica'),
      timezones: [
        { value: 'America/New_York', label: 'New York (EDT, UTC-4)' },
        { value: 'America/Chicago', label: 'Chicago (CDT, UTC-5)' },
        { value: 'America/Denver', label: 'Denver (MDT, UTC-6)' },
        { value: 'America/Los_Angeles', label: 'Los Angeles (PDT, UTC-7)' },
        { value: 'America/Toronto', label: 'Toronto (EDT, UTC-4)' },
        { value: 'America/Vancouver', label: 'Vancouver (PDT, UTC-7)' },
        { value: 'America/Mexico_City', label: 'Mexico City (CDT, UTC-5)' },
      ]
    },
    {
      label: t('timezone.regions.asia'),
      timezones: [
        { value: 'Asia/Dubai', label: 'Dubai (GST, UTC+4)' },
        { value: 'Asia/Tokyo', label: 'Tokyo (JST, UTC+9)' },
        { value: 'Asia/Shanghai', label: 'Shanghai (CST, UTC+8)' },
        { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT, UTC+8)' },
        { value: 'Asia/Singapore', label: 'Singapur (SGT, UTC+8)' },
        { value: 'Asia/Seoul', label: 'Seoul (KST, UTC+9)' },
        { value: 'Asia/Bangkok', label: 'Bangkok (ICT, UTC+7)' },
        { value: 'Asia/Kolkata', label: 'Mumbai/Delhi (IST, UTC+5:30)' },
      ]
    },
    {
      label: t('timezone.regions.oceania'),
      timezones: [
        { value: 'Australia/Sydney', label: 'Sydney (AEDT, UTC+11)' },
        { value: 'Australia/Melbourne', label: 'Melbourne (AEDT, UTC+11)' },
        { value: 'Australia/Brisbane', label: 'Brisbane (AEST, UTC+10)' },
        { value: 'Australia/Perth', label: 'Perth (AWST, UTC+8)' },
        { value: 'Pacific/Auckland', label: 'Auckland (NZDT, UTC+13)' },
      ]
    },
    {
      label: t('timezone.regions.southAmerica'),
      timezones: [
        { value: 'America/Sao_Paulo', label: 'São Paulo (BRT, UTC-3)' },
        { value: 'America/Buenos_Aires', label: 'Buenos Aires (ART, UTC-3)' },
        { value: 'America/Santiago', label: 'Santiago (CLT, UTC-3)' },
        { value: 'America/Lima', label: 'Lima (PET, UTC-5)' },
        { value: 'America/Bogota', label: 'Bogotá (COT, UTC-5)' },
      ]
    },
    {
      label: t('timezone.regions.africa'),
      timezones: [
        { value: 'Africa/Cairo', label: 'Kairo (EET, UTC+2)' },
        { value: 'Africa/Johannesburg', label: 'Johannesburg (SAST, UTC+2)' },
        { value: 'Africa/Lagos', label: 'Lagos (WAT, UTC+1)' },
        { value: 'Africa/Nairobi', label: 'Nairobi (EAT, UTC+3)' },
      ]
    },
    {
      label: t('timezone.regions.other'),
      timezones: [
        { value: 'UTC', label: 'UTC (koordinierte Weltzeit)' },
      ]
    }
  ]
  return (
    <div>
      <label htmlFor="timezone-select" className="block text-sm font-medium text-gray-700 mb-2">
        {t('timezone.label')}
      </label>
      <select
        id="timezone-select"
        value={timezone}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white text-gray-900"
      >
        {TIMEZONE_OPTIONS.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.timezones.map((tz) => (
              <option key={tz.value} value={tz.value}>
                {tz.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      <p className="mt-2 text-sm text-gray-600">
        {t('timezone.help')}
      </p>
    </div>
  )
}

export default TimezoneDropdown
